import { render } from "./ShareholderList.vue?vue&type=template&id=81ed3da8"
import script from "./ShareholderList.vue?vue&type=script&lang=js"
export * from "./ShareholderList.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__